import {readCinematicMasks,type CinematicMasks} from '../../protocol/cinematic-masks';
import type {UndoableState} from '../../vendor/src/features/remotion-editor/editor/state/types';
export function createItemMaskData(document:UndoableState,itemId:string):CinematicMasks{
  const item=document.items[itemId];
  if((item?.sourceBrandIntro||item?.cinematicMotion||item?.sourceSlide))throw new Error('모션 카드에 모자이크를 적용하려면 원본 편집에서 설정해 주세요.');
  if(!item||(item.type!=='video'&&item.type!=='image'))throw new Error('영상 또는 이미지를 선택해 주세요.');
  const sourceUrl=document.assets[item.assetId]?.remoteUrl;
  if(!sourceUrl)throw new Error('파일 보관이 끝난 뒤 모자이크를 추가해 주세요.');
  return readCinematicMasks({version:1,sourceUrl,canvasWidth:document.compositionWidth,canvasHeight:document.compositionHeight,
    fit:{x:item.left,y:item.top,w:item.width,h:item.height},timeOrigin:item.type==='video'?item.videoStartFromInSeconds:0,
    ...(item.type==='image'?{frozenTime:0}:{}),regions:[]})!;
}
export function editCinematicMasks(document:UndoableState,itemId:string,expected:string,next:CinematicMasks|undefined):UndoableState{
  const item=document.items[itemId];
  if((item?.sourceBrandIntro||item?.cinematicMotion||item?.sourceSlide))throw new Error('모션 카드에 모자이크를 적용하려면 원본 편집에서 설정해 주세요.');
  if(!item||(item.type!=='video'&&item.type!=='image'))throw new Error('선택한 원본이 바뀌었습니다. 다시 선택해 주세요.');
  if(document.tracks.some(track=>track.items.includes(itemId)&&track.locked))throw new Error('트랙 잠금을 해제한 뒤 수정해 주세요.');
  if(JSON.stringify(item.cinematicMasks??null)!==expected)throw new Error('모자이크가 바뀌었습니다. 최신 설정에서 다시 수정해 주세요.');
  if(next)readCinematicMasks(next);
  const updated={...item};
  if(next)updated.cinematicMasks=structuredClone(next);else delete updated.cinematicMasks;
  return {...document,items:{...document.items,[itemId]:updated}};
}
